import {IntermediatePart} from "../../intermediatePart";

export default class Cutouts extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'cutouts';
    this.partName = 'Cutouts';
    this.translateId = "visualizer.kitchen.countertop.cutouts";
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Cutouts());
  }

  setZIndex() {

  }
}
